import { NetworkStatus } from '@cbridge-utils/network';
import { IUserSettingsState } from './userSettings.interface';

export const initialState: IUserSettingsState = {
  settings: {},
  networkStatus: NetworkStatus.Started,
};

/** Collapses bursts of saveSetting dispatches (e.g. a column drag sequence) into one PATCH. */
export const SAVE_SETTINGS_DEBOUNCE_MS = 500;
